export const LOAD_APP_DATA = 'loadAppData';
